import styled from "styled-components";
import { Colors } from "../../../styles/colors";

export const Container = styled.div`
	display: flex;
	background-color: ${Colors?.primary_blue_k_main};
	border-radius: 30px;
	color: black;
	padding-right: 1.8rem;
	padding-left: 1.8rem;
	padding-top: 3.8rem;
	padding-bottom: 2.8rem;
	flex-direction: column;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	position: relative;
	height: 85vh;
	width: 70vh;
	position: relative;

	
	.close {
		width: 1.738rem;
		position: absolute;
		right: 1.5rem;
		top: 1.5rem;

		cursor: pointer;
	}

	.image {
		@media screen and (max-height: 700px) {
			width: 316px;
			height: 415px;
		}
		@media screen and (max-height: 610px) {
			width: 251px;
			height: 350px;
		}
	}
`;

export const Title = styled.p<{color:string}>`
	display: inline;
	font-family: 'Kanit-Regular';
	color: ${({color})=> color};
	font-weight: 700;
	font-size: 30px;

	@media screen and (min-height: 900px) {
		font-size: 3rem;
	}

`;

export const ContainerConditions = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: flex-start;
	margin-bottom: 50px;
	padding: 15px;
`;
export const OptionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: flex-start;
	padding-left: 10px;
	margin-top:10px;
	flex-direction: row;
`;
export const FooterContainer = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 120px;
	width: 85%;
	padding-bottom: 30px;
	align-self: center;
	align-items: center;
	justify-content: space-between;
	position: absolute;
	z-index: 2;
	bottom: 0;
`
export const ButtonAction = styled.div`
	display: flex;
	width: 100%;
	border-radius: 12px;
	padding: 12px;
	align-items: center;
	justify-content: center;
	background-color: ${Colors.secondary_green_k_main};
	cursor: pointer;
`;
export const Dispensar = styled.p`
	display: flex;
	font-family: "NotoSans-Regular";
	font-size: 1.1rem;
	color: ${Colors.neutral_grey_k_5};
	text-decoration: underline;
	text-decoration-color: ${Colors.neutral_grey_k_5};
	cursor: pointer;
	margin-top: 20px;
`;
export const Option = styled.p<{width?: string}>`
	width: ${({width})=> width ? `${width}` : 'auto'};
	font-family: "NotoSans-Regular";
	font-size: 1.25rem;
	color: ${Colors.neutral_grey_k_5};
	font-weight: 500;

	@media screen and (max-height: 660px) {
		font-size: 1.1rem;
	}
	@media screen and (max-height: 600px) {
		font-size: 1rem;
	}
	@media screen and (min-height: 800px) {
		font-size: 1.5rem;
		margin-top:10px;
	}
	@media screen and (min-height: 900px) {
		font-size: 1.8rem;
		margin-top:10px;
	}

`;